import { registerWidget, DME, DMEData } from "dmeditor";

export const IconDefinition: DME.Widget = {
  type: "mf-icon",
  icon: "matchfit",
  name: "Icon",
  category: "basic",
  settings: [
    {
      name: "Icon type",
      property: ".iconType",
      settingComponent: "select",
      parameters: {
        defaultValue: "search",
        options: [
          { label: "College matcher", value: "college-matcher-icon.png" },
          { label: "Explore", value: "explore-icon.png" },
          { label: "Featured", value: "featured-icon.png" },
          { label: "Research", value: "research-icon.png" },
          { label: "Search", value: "search-icon.png" },
          { label: "Top favorites", value: "top-favorites.png" },
          { label: "Track", value: "track-icon.png" },
          { label: "What's new", value: "whats-new.png" },
        ],
      },
    },
  ],
  events: {
    updateData: () => {},
    createBlock: (): DMEData.CreatedBlock<IconEnitity> => {
      return {
        type: "mf-icon",
        data: {
          iconType: "search",
        },
      };
    },
  },
};

export interface IconEnitity {
  iconType: string;
}

export const IconRender = (props: DME.WidgetRenderProps<IconEnitity>) => {
  const {
    blockNode: { data },
  } = props;
  const { iconType } = data;

  return (
    <div style={{ marginBottom: 15 }}>
      <img style={{ height: 46 }} src={"/images/icon/" + iconType} />
    </div>
  );
};

export default () => {
  registerWidget(IconDefinition, {
    render: IconRender,
  });
};
